<div class="bloco-header">
  <div class="bloco-header-esq">
    <mat-icon class="bloco-icone">{{ icone }}</mat-icon>
    <span class="bloco-nome">{{ rotulo }}</span>
  </div>
  <div class="bloco-header-dir">
    <button type="button" class="bloco-acao" [disabled]="primeiro || disabled" (click)="moverTopo.emit()" title="Mover para o início">
      <mat-icon>keyboard_double_arrow_up</mat-icon>
    </button>
    <button type="button" class="bloco-acao" [disabled]="primeiro || disabled" (click)="subir.emit()" title="Mover para cima">
      <mat-icon>expand_less</mat-icon>
    </button>
    <button type="button" class="bloco-acao" [disabled]="ultimo || disabled" (click)="descer.emit()" title="Mover para baixo">
      <mat-icon>expand_more</mat-icon>
    </button>
    <button type="button" class="bloco-acao" [disabled]="ultimo || disabled" (click)="moverFundo.emit()" title="Mover para o fim">
      <mat-icon>keyboard_double_arrow_down</mat-icon>
    </button>
    <button type="button" class="bloco-acao bloco-acao-recolher"
            [class.ativo]="!recolhido"
            (click)="alternarRecolhido()"
            [attr.aria-expanded]="!recolhido"
            [title]="recolhido ? 'Expandir bloco' : 'Recolher bloco'">
      <mat-icon>{{ recolhido ? 'unfold_more' : 'unfold_less' }}</mat-icon>
    </button>
    <button type="button" class="bloco-acao bloco-acao-excluir" [disabled]="disabled" (click)="excluir.emit()" title="Excluir bloco">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</div>

<ng-template #alinhamentoTpl>
  <div class="grupo-alinhamento">
    @for (a of alinhamentos; track a) {
      <button type="button" class="btn-align" [class.ativo]="(bloco.alinhamento ?? 'left') === a"
        [disabled]="disabled" (click)="definirAlinhamento(a)" [title]="'Alinhar ' + rotuloAlinhamento(a)">
        <mat-icon>{{ iconeAlinhamento(a) }}</mat-icon>
      </button>
    }
  </div>
</ng-template>

@if (recolhido && exibeAlinhamentoRecolhido) {
  <div class="bloco-controles-recolhido">
    <ng-container *ngTemplateOutlet="alinhamentoTpl"></ng-container>
  </div>
}

<div class="bloco-corpo" [hidden]="recolhido">
  @switch (bloco.tipo) {
    @case ('TITULO') {
      <app-form-field
        #tituloInput
        placeholder="Título do e-mail"
        heightFormField="40px"
        [value]="bloco.texto ?? ''"
        [disabled]="disabled"
        (changeValue)="atualizarTexto($event)">
      </app-form-field>

      <div class="linha-rodape-campo">
        <ng-container *ngTemplateOutlet="alinhamentoTpl"></ng-container>
        @if (variaveis.length) {
          <div class="chips-variaveis">
            @for (variavel of variaveis; track variavel.token) {
              <button type="button" class="chip-variavel" [disabled]="disabled"
                (click)="inserirVariavelTitulo(variavel.token)">{{ variavel.token }}</button>
            }
          </div>
        }
      </div>
    }

    @case ('TEXTO') {
      <app-form-textarea
        #textoTextarea
        placeholder="Digite o texto do e-mail"
        heightFormField="48px"
        maxHeightFormField="48px"
        [crescerSemScroll]="true"
        [autoFocus]="false"
        [value]="bloco.texto ?? ''"
        [disabled]="disabled"
        (changeValue)="atualizarTexto($event)">
      </app-form-textarea>

      <div class="linha-rodape-campo">
        <ng-container *ngTemplateOutlet="alinhamentoTpl"></ng-container>
        @if (variaveis.length) {
          <div class="chips-variaveis">
            @for (variavel of variaveis; track variavel.token) {
              <button type="button" class="chip-variavel" [disabled]="disabled"
                      (click)="inserirVariavelTexto(variavel.token)">{{ variavel.token }}</button>
            }
          </div>
        }
      </div>
    }

    @case ('IMAGEM') {
      <div class="linha-imagem">
        <button type="button" class="btn-anexar-imagem" [disabled]="disabled" (click)="abrirSeletorImagem()">
          <mat-icon>upload</mat-icon>
          <span>Anexar imagem</span>
        </button>
        <input #imagemInput type="file" accept="image/png,image/jpeg,image/gif,image/webp" hidden (change)="anexarImagem($event)" />
      </div>

      @if (bloco.urlImagem) {
        <div class="thumb-imagem" [style.text-align]="bloco.alinhamento ?? 'center'">
          <img [src]="bloco.urlImagem" alt="Pré-visualização" />
        </div>
      }

      <app-form-field
        placeholder="Ou cole a URL da imagem"
        heightFormField="40px"
        [value]="urlImagemExibida"
        [disabled]="disabled"
        (changeValue)="atualizarCampo('urlImagem', $event)">
      </app-form-field>

      <div class="linha-controles-imagem">
        <ng-container *ngTemplateOutlet="alinhamentoTpl"></ng-container>
        <div class="grupo-largura">
          <input type="range" min="10" max="100" class="slider-largura"
            [value]="bloco.largura ?? 100" [disabled]="disabled" (input)="definirLargura($event)" />
          <span class="valor-largura">{{ bloco.largura ?? 100 }}%</span>
        </div>
      </div>
    }

    @case ('BOTAO') {
      <app-form-field
        placeholder="Texto do botão"
        heightFormField="40px"
        [value]="bloco.labelBotao ?? ''"
        [disabled]="disabled"
        (changeValue)="atualizarCampo('labelBotao', $event)">
      </app-form-field>
      <app-form-field
        #linkBotaoInput
        placeholder="https://exemplo.com.br/link"
        heightFormField="40px"
        [value]="bloco.urlBotao ?? ''"
        [disabled]="disabled"
        (changeValue)="atualizarCampo('urlBotao', $event)">
      </app-form-field>

      @if (variaveis.length) {
        <div class="chips-variaveis">
          <span class="dica-variavel">Inserir variável no link:</span>
          @for (variavel of variaveis; track variavel.token) {
            <button type="button" class="chip-variavel" [disabled]="disabled"
              (click)="inserirVariavelLinkBotao(variavel.token)">{{ variavel.token }}</button>
          }
        </div>
      }

      <div class="linha-rodape-campo">
        <ng-container *ngTemplateOutlet="alinhamentoTpl"></ng-container>
        <div class="grupo-cores">
          <button type="button" class="swatch swatch-primaria" [class.ativo]="corAtualEhPrimaria"
            [disabled]="disabled" (click)="definirCor('#993DF5')" title="Cor primária"></button>

          @for (c of coresBotao; track c) {
            <button type="button" class="swatch" [class.ativo]="bloco.corBotao === c" [style.background]="c" [disabled]="disabled" (click)="definirCor(c)" [title]="c"></button>
          }

          <label class="swatch swatch-picker" [class.ativo]="corAtualEhPersonalizada" title="Escolher outra cor">
            <input type="color" [value]="corParaInputPicker" [disabled]="disabled" (input)="definirCorPersonalizada($event)" />
            <mat-icon>colorize</mat-icon>
          </label>
        </div>
      </div>
    }

    @case ('VARIAVEL') {
      <span class="dica-variavel">Selecione a variável a inserir:</span>
      <div class="chips-variaveis">
        @for (variavel of variaveis; track variavel.token) {
          <button type="button" class="chip-variavel" [class.ativo]="bloco.texto === variavel.token"
                  [disabled]="disabled" (click)="atualizarTexto(variavel.token)">{{ variavel.token }}</button>
        }
      </div>
    }

    @case ('DIVISOR') {
      <div class="placeholder-divisor">Uma linha divisória será exibida aqui.</div>
    }

    @case ('HTML') {
      <app-form-textarea
        #htmlTextarea
        placeholder="Cole aqui o HTML do e-mail"
        heightFormField="96px"
        maxHeightFormField="96px"
        [crescerSemScroll]="true"
        [autoFocus]="false"
        [value]="bloco.html ?? ''"
        [disabled]="disabled"
        (changeValue)="atualizarCampo('html', $event)">
      </app-form-textarea>

      <div class="linha-rodape-campo">
        <ng-container *ngTemplateOutlet="alinhamentoTpl"></ng-container>
        @if (variaveis.length) {
          <div class="chips-variaveis">
            <span class="dica-variavel">Inserir variável no HTML:</span>
            @for (variavel of variaveis; track variavel.token) {
              <button type="button" class="chip-variavel" [disabled]="disabled"
                (click)="inserirVariavelHtml(variavel.token)">{{ variavel.token }}</button>
            }
          </div>
        }
      </div>
    }
  }
</div>
